import {ReceiverGroup} from "./ReceiverGroup"
import { Language } from "./Language"

export type Receiver = {
    receiverId?: string,
    emailAddress: string
    firstName: string,
    lastName: string,
    gender: string,
    language: Language,
    receiverGroups: ReceiverGroup[],
    sharedMailbox?: boolean
}

export enum Gender {
    MALE= "m",
    FEMALE = "f",
    DIVERS = "x"
}